import clsx from "clsx";
interface SpinnerProps {
  className?: string;
}

export function Spinner({ className }: SpinnerProps) {


return (
    <div
        className={clsx(
            "h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-amber-500",
            className
        )}
    />
);
}